import React from "react";
import { FiHome, FiUsers, FiMapPin, FiCamera, FiEdit, FiTrash2, FiPlus } from "react-icons/fi";
import { useTheme } from "../../../context/ThemeContext";

export default function OrganizationGrid({
  organizations = [],
  onSelectOrg,
  onAddOrg,
  onEditOrg,
  onDeletedOrg,
}) {
  const { theme } = useTheme();

  const cardBase =
    theme === "dark"
      ? "bg-darkCard border border-gray-700 text-gray-100"
      : "bg-white border border-gray-200 text-gray-900";

  return (
    <div className="space-y-6">
      {/* Header */}
      <div
        className={`flex flex-col md:flex-row justify-between items-start md:items-center gap-4 p-5 rounded-xl shadow ${
          theme === "dark" ? "bg-darkCard" : "bg-white border border-gray-200"
        }`}
      >
        <div>
          <h1 className="text-2xl font-bold">Organizations</h1>
          <p className="text-gray-500">Manage organizations and view details.</p>
        </div>
        <button
          onClick={() => onAddOrg && onAddOrg()}
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm shadow"
        >
          <FiPlus /> Add Organization
        </button>
      </div>

      {/* Grid */}
      {organizations.length === 0 ? (
        <p className="text-gray-500 text-center py-20">No organizations found.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
          {organizations.map((org) => {
            const cameraCount =
              org.sites?.reduce((sum, s) => sum + (s.camera_count || 0), 0) || 0;

            return (
              <div
                key={org.id}
                className={`${cardBase} rounded-xl p-5 cursor-pointer transition hover:shadow-lg hover:border-blue-500`}
                onClick={() => onSelectOrg(org)}
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <FiHome className="text-blue-500 text-xl" />
                    <h2 className="font-semibold text-lg truncate">{org.name}</h2>
                  </div>
                  <div className="flex items-center gap-2">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        onEditOrg && onEditOrg(org);
                      }}
                      className="text-blue-500 hover:text-blue-700"
                    >
                      <FiEdit />
                    </button>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        if (window.confirm(`Delete ${org.name}?`))
                          onDeletedOrg && onDeletedOrg(org.id);
                      }}
                      className="text-red-500 hover:text-red-700"
                    >
                      <FiTrash2 />
                    </button>
                  </div>
                </div>

                <div className="mt-4 flex justify-between text-sm text-gray-500">
                  <div className="flex items-center gap-2">
                    <FiMapPin className="text-green-500" /> {org.site_count || 0} Sites
                  </div>
                  <div className="flex items-center gap-2">
                    <FiUsers className="text-purple-500" /> {org.user_count || 0} Users
                  </div>
                  <div className="flex items-center gap-2">
                    <FiCamera className="text-cyan-500" /> {cameraCount} Cameras
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

